import styled from 'styled-components'
import {device} from '../../../shared-ui/theme'
import BackgroundImage from 'gatsby-background-image'
import { BgImage } from 'gbimage-bridge';

export const BannerArea = styled(BackgroundImage)`
    padding-top: 195px;
    padding-bottom: 204px;
`; 

export const BannerBgArea = styled(BgImage)`
    padding-top: 195px;
    padding-bottom: 204px;    
`; 


export const BannerTextWrap = styled.div `
    text-align: center;
`;
